import type { TrailDefinition, TrailContext } from './types'

interface Ember {
  x: number
  y: number
  vx: number
  vy: number
  life: number
  maxLife: number
  size: number
}

const MAX_PARTICLES = 60

export const embers: TrailDefinition = {
  id: 'embers',
  name: 'Embers',

  init() {
    return [] as Ember[]
  },

  update(state: unknown, ctx: TrailContext) {
    const particles = state as Ember[]
    const dt = ctx.deltaTime / 1000

    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(3, MAX_PARTICLES - particles.length)
      for (let i = 0; i < spawnCount; i++) {
        particles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 10,
          y: ctx.mouseY + (Math.random() - 0.5) * 10,
          vx: (Math.random() - 0.5) * 40,
          vy: -(30 + Math.random() * 50),
          life: 1,
          maxLife: 0.5 + Math.random() * 0.5,
          size: 1 + Math.random() * 2
        })
      }
    }

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i]
      p.life -= dt / p.maxLife
      p.x += p.vx * dt
      p.y += p.vy * dt
      // Turbulence
      p.vx += (Math.random() - 0.5) * 60 * dt
      p.vy += (Math.random() - 0.5) * 20 * dt
      p.vy -= 15 * dt // upward drift

      if (p.life <= 0) {
        particles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const particles = state as Ember[]
    const c = ctx.ctx

    for (const p of particles) {
      const alpha = Math.max(0, p.life)
      const t = 1 - p.life

      // Color shifts from bright orange → red → dark
      const r = Math.round(255 - t * 80)
      const g = Math.round(180 - t * 160)
      const b = Math.round(40 - t * 40)

      // Core dot
      c.beginPath()
      c.arc(p.x, p.y, p.size * alpha, 0, Math.PI * 2)
      c.fillStyle = `rgba(${r}, ${g}, ${b}, ${alpha})`
      c.fill()

      // Glow
      const glowRadius = p.size * 4 * alpha
      const gradient = c.createRadialGradient(p.x, p.y, 0, p.x, p.y, glowRadius)
      gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, ${alpha * 0.3})`)
      gradient.addColorStop(1, 'transparent')
      c.fillStyle = gradient
      c.fillRect(p.x - glowRadius, p.y - glowRadius, glowRadius * 2, glowRadius * 2)
    }
  }
}
